export const reduxKey = 'environment';
